import { Fragment, useMemo } from "react";
import { ITimelineItemBase } from "../../../../components/shared/TimelineCalendar/timeline.types";
import VitalsInputRow from "./VitalsInputRow";
import VitalsInputList from "./VitalsInputList";
interface Props {
  items: ITimelineItemBase[];
  unit: string;
  suffix: string | undefined;
  disabled?: boolean;
  handleChange?: ((items: ITimelineItemBase[]) => void) | undefined;
  handleDeleteItems?: ((id: string | string[]) => void) | undefined;
}
const VitalsInputRenderer = ({
  items,
  unit,
  disabled,
  suffix,
  handleChange,
  handleDeleteItems,
}: Props) => {
  const groupedItems = useMemo(() => {
    const grouped: Record<string, ITimelineItemBase[]> = {};
    items.forEach((item: ITimelineItemBase) => {
      const itemDate = item.start.split("T")[0];
      if (grouped[itemDate]) {
        grouped[itemDate].push(item);
      } else {
        grouped[itemDate] = [item];
      }
    });
    return grouped;
  }, [items]);
  const renderRow = (items: ITimelineItemBase[], date: string) =>
    unit === "vitals_pressure" ? (
      <Fragment>
        <VitalsInputRow
          onChange={handleChange}
          onDeleteItem={handleDeleteItems}
          items={items}
          subResource="SYS"
          date={date}
          disabled={disabled}
        />
        <VitalsInputRow
          onChange={handleChange}
          onDeleteItem={handleDeleteItems}
          items={items}
          subResource="DIA"
          date={date}
          disabled={disabled}
        />
      </Fragment>
    ) : (
      <VitalsInputRow
        onChange={handleChange}
        onDeleteItem={handleDeleteItems}
        items={items}
        suffix={suffix}
        date={date}
        disabled={disabled}
      />
    );

  return (
    <VitalsInputList
      renderInputRow={renderRow}
      groupedItems={groupedItems}
      onDeleteItems={handleDeleteItems}
      onChangeItems={handleChange}
      disabled={disabled}
    />
  );
};
export default VitalsInputRenderer;
